var render = function render(){var _vm=this,_c=_vm._self._c;return _c('projectOverviewJD',{attrs:{"bgimg":"bg2","projectCode":"jkjd"}})
}
var staticRenderFns = []

export { render, staticRenderFns }